import { Button } from "react-bootstrap";

import { Navi } from "./Navi";
import { Footer } from "./Footer";

export const ThanksPage = () => {
  return (
    <div style={{ fontFamily: "Noto Sans JP" }}>
      <Navi />
      <div className="py-5"></div>
      <div className="container text-center text-md-start">
        <div className="row align-items-center justify-content-center">
          <div className="col-md-5">
            <div className="fs-3 pb-2">
              お問い合わせありがとうございました。
            </div>
            <div className="text-center pt-4">
              <Button href="/" className="px-5" size="lg">
                TOPへ
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer style={{ position: "absolute", bottom: "0" }} />
    </div>
  );
};
